import React from "react";
import Modal from '../../component/Inc/Modal';
function PopRefund(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input pop_refund_report" popSize="s">
      <h2 className='pop_tit'>환불 보고서</h2>
      <div className="content_container scroll">
        <section className='search search_top'>
          <select className="select">
            <option value="수업 선택">수업 선택</option>
          </select>
          <input type="text" placeholder='검색할 내용을 입력해 주세요.' className="input xs" />
          <button className="com_btn gray xs icon_search"></button>
          
        </section>
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <span className="name">홍길동103</span>
              <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
            </div>
            <div className="info">
              <span className="tit">과목</span>
              <div className="cont">
                <p className="txt">국어 l 2T</p>
              </div>
            </div>
            <div className="info">
              <span className="tit">수업진행</span>
              <div className="cont">
                <p className="txt">10/35 회차 진행중</p>
              </div>
            </div>
            <div className="info">
              <span className="tit">교사</span>
              <span className="cont">김교사103</span>
            </div>
            <div className="info">
              <span className="tit">담임</span>
              <span className="cont">김담임789</span>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">결제일</span>
              <span className="cont com_blue_txt">2023, 05, 12</span>
            </div>
            <div className="info">
              <span className="tit">총 결제금액</span>
              <span className="cont com_blue_txt">45,000</span>
            </div>
            <div className="info">
              <span className="tit">결제 방법1</span>
              <span className="cont com_blue_txt">45,000원ㅣ카드 134-32141-3211</span>
            </div>
            <div className="info">
              <span className="tit">결제방법2</span>
              <span className="cont com_blue_txt">78,000원<br/>무통장 입금ㅣ국민 4567- 4657- 6547 -65647</span>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">환불 계좌</span>
              <span className="cont com_blue_txt">홍길동ㅣ국민 4657-6547-2134-3214</span>
            </div>
            <div className="info">
              <span className="tit">수업 잔여기준<br/>환불 금액</span>
              <span className="cont com_blue_txt">45,000원</span>
              <button className="btn_report">출석부 보기</button>
            </div>
          </div>
        </div>
        <div className="com_board_box">
          <div className="board_item">
            <div className="refund">
              <span className="cont">
                <span className="bold">환불금액</span> = (입금금액 – ((1회 수업료X 수업진행 횟 수)) – (위약금)
                <button className="btn_report">위약금 정책</button>
              </span>
              <hr className="com_divider" />
              <div className="com_input_wrap flex_between">
                <span className="calc_txt">(567,000 – ((20,000X 12)) –</span>
                <input type="text" className="input xs" placeholder="위약금 입력" />
              </div>
              <strong className="total com_blue_txt">환불금액 : 465,000원</strong>
            </div>
          </div>
        </div>
        <div className="com_board_box">
          <div className="board_item">
            <ul className="com_input_sec account_sec">
              <li className="tit_field">
                <span>환불 계좌</span>
                <input type="checkbox" className="com_chk"/><label>직접입력</label>
              </li>
              <li className="input_field com_input_wrap flex_row">
                <select className="select">
                  <option>선택</option>
                </select>
                <input type="text" placeholder="계좌주 입력" className="input_name"/>
                <input type="text" placeholder="계좌 번호 입력"/>
              </li>
              <li className="tit_field">
              상세 사유 입력
              </li>
              <li className="input_field">
                <input type="text" placeholder="입력"/>
              </li>
            </ul>
          </div>
          
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopRefund;